import {useEffect, useRef, useState} from "react";
import Button from "../button/button.jsx";

const LegendDropdown = ({items, hint}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!containerRef.current?.contains(event.target)) setIsOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={containerRef} className="relative print:hidden">
      <Button
        title="Exibir legenda"
        className="h-5! w-5! !px-0 rounded-full!"
        onClick={() => setIsOpen(current => !current)}
      >
        ?
      </Button>

      {isOpen && (
        <div className="absolute right-0 top-full z-20 mt-2 w-48 rounded-md border border-[#E2E8F0] bg-white p-3 text-[13px] text-gray-700 shadow-lg">
          <div className="mb-2 font-bold text-[#063A6C]">Legenda</div>
          {items.map(({label, colorClassName, lineClassName}) => (
            <div key={label} className="flex items-center gap-2 py-1">
              <span className={lineClassName || `h-3 w-6 rounded ${colorClassName}`} />
              <span>{label}</span>
            </div>
          ))}
          {hint && (
            <div className="mt-2 border-t border-[#E2E8F0] pt-2 text-[11px] text-gray-500">
              {hint}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LegendDropdown;
